/**
 * @file Pauses a distribution schedule.
 */
import useAction from "./useAction";

const LABEL_SCHEDULE_PAUSED = "Schedule is paused";

type Props = {
  scheduleId?: string;
  disableSchedule: (scheduleId: string) => Promise<unknown>;
};

/**
 * Pauses the schedule.
 */
const useDisable = ({ scheduleId, disableSchedule }: Props) => {
  const { onAction: onDisableSchedule, isLoading } = useAction({
    scheduleId,
    action: disableSchedule,
    successMessage: LABEL_SCHEDULE_PAUSED,
  });

  return { onDisableSchedule, isLoading };
};

export default useDisable;

